(ns app.front.view.admin.migration.fix-cashiers
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/fix-cashier-grants
    :title     "Update cashier authorizations with grants having right permissions"
    :help-text "Removes cashier grants with wrong permissions, and updates cashier group authorizations to use the grant
                with right permissions."}
   match])

(def route
  {:name        :view/admin.migration.fix-cashiers
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/fix-cashier-grants]))}]})
